/**
 * @file paddle hack topic
 * @author wanzhongyun
 */

import React from 'react';
import { RightOutlined } from '@ant-design/icons';
import { RootObject } from '../../type';

import './style.less';


const HackTopic = (props: RootObject["hackathonBrowseTopic"]) => {

    const {
        titleImageUrl,
        topicList,
        allTopicWord,
        allTopicLink
    } = props;
    
    return (
        <div className='paddle-hack-topic-wrapper'>
            <div className='paddle-hack-topic-wrapper-content'>
                <div className='paddle-hack-topic-wrapper-content-header'>
                    <img className='paddle-hack-topic-title' src={titleImageUrl} alt='' />

                </div>
                {/* <div className='paddle-hack-topic-card-wrapper'>
                    {
                        topicList.map(item => <div className='paddle-hack-topic-card' key={item.titleEn} onClick={() => { window.open(item.checkAllLink) }}>
                            <img className='paddle-hack-topic-card-icon' src={item.imageUrl} alt={item.titleZh} />
                            <div className='paddle-hack-topic-card-en-title'>{item.titleEn}</div>
                            <div className='paddle-hack-topic-card-zh-title'>{item.titleZh}</div>
                            <div className='paddle-hack-topic-desc'>{item.desc}</div>
                            <div className="paddle-hack-topic-check-all-wrapper">
                                <div className='paddle-hack-topic-check-all'>
                                    <span className='paddle-hack-topic-check-all-word'>{item.checkAll}</span>
                                    <span className='paddle-hack-topic-check-arrow' />
                                </div>
                            </div>
                        </div>)
                    }

                </div> */}
                {/* 任务模块 */}
                <div className='paddle-hack-topic-module-wrapper'>

                    {
                      topicList.map((item) => {
                            return (
                                <div className={item.checkAllLink ? "paddle-hack-topic-module" : "paddle-hack-topic-module paddle-hack-topic-module-disable"} key={item.titleEn}  onClick={() => { item.checkAllLink && window.open(item.checkAllLink)}}>
                                    <div className="paddle-hack-topic-module-back-image" style={{background:`url(${item.imageUrl})`}}></div>
                                    <div className="paddle-hack-topic-modeule-content">
                                        <div className="paddle-hack-topic-modeule-content-cn-title">
                                        {item.titleZh}
                                        </div>
                                        <div className="paddle-hack-topic-modeule-content-en-title">
                                        {item.titleEn}
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }

                </div>
            </div>
            <div className='paddle-hack-topic-all-link'>
                <a href={allTopicLink} target='_blank' rel="noreferrer" >{allTopicWord}<RightOutlined className='paddle-pilot-rights-detail-link-icon' /></a>
            </div>
        </div>
    );
};

export default HackTopic;